import { Fragment, useEffect, useState } from 'preact/compat';

import { useWidget } from '../../context/WidgetContext';
import { useWidgetVisibility } from '../../hooks/useWidgetVisibility';
import type { TokenManagerData } from '../../types/token-manager';
import { tokenManager } from '../../utils';

import { TriggerButton } from '../TriggerButton';
import { WidgetPanel } from '../WidgetPanel';
import { WidgetSubscriptions } from '../WidgetSubscriptions';

export const Widget = () => {
  // userId берётся из JWT токена (поле sub) — единственный источник истины
  const [userId, setUserId] = useState<string | null>(tokenManager.getUserUuid());

  useEffect(() => {
    const callback = (data?: TokenManagerData) => {
      if (data?.userUuid) {
        setUserId(data.userUuid);
      }
    };

    tokenManager.subscribe(callback);

    return () => tokenManager.unsubscribe(callback);
  }, []);

  const { setHasNewMessage, hasNewMessage, hideTriggerButton } = useWidget();
  const widgetVisibility = useWidgetVisibility(setHasNewMessage);

  return (
    <Fragment>
      {userId && <WidgetSubscriptions userId={userId} />}
      {!hideTriggerButton && <TriggerButton onClick={widgetVisibility.toggleWidget} hasNotifyBadge={hasNewMessage} />}
      <WidgetPanel onClose={widgetVisibility.toggleWidget} isOpen={widgetVisibility.isVisible} />
    </Fragment>
  );
};
